import lodash from "lodash";
import { createColumnInlineInputNumber, createColumnInlineSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { createButtonCreate } from "../../../../../utils/button";
import { conditionFormChecker, onClickDeleteAllClient } from "../../../../../utils/form";
import { createLoading } from "../../../../../utils/loading";
import { createManageDelete, createManageExportCsv, createPage } from "../../../../../utils/page";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/hazPackage";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const callHazPackage = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_PACKAGE", value: searchQuery });
export const callHazPackageUnit = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_PACKAGE_UNIT", value: searchQuery });

export const createColumns = ({ props, data }) => {
    const { viewOnly, itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const columns = [];
    columns.push(
        createColumnInlineSelect({
            title: () => i18n.global.t("model.hazPackage.refPackage1"),
            dataIndex: "refPackage1",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: callHazPackage, optLabel: "value" }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        list: callHazPackage,
                        optLabel: "value",
                        "onUpdate:value": value => (record.refPackage1 = value)
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                )
        })
    );
    columns.push(
        createColumnInlineSelect({
            title: () => i18n.global.t("model.hazPackage.refPackage2"),
            dataIndex: "refPackage2",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: callHazPackage, optLabel: "value" }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        list: callHazPackage,
                        optLabel: "value",
                        "onUpdate:value": value => (record.refPackage2 = value)
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                )
        })
    );
    columns.push(
        createColumnInlineSelect({
            title: () => i18n.global.t("model.hazPackage.refPackage3"),
            dataIndex: "refPackage3",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: callHazPackage, optLabel: "value" }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        list: callHazPackage,
                        optLabel: "value",
                        "onUpdate:value": value => (record.refPackage3 = value)
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                )
        })
    );
    columns.push(
        createColumnInlineInputNumber({
            title: () => i18n.global.t("model.hazPackage.size"),
            dataIndex: "size",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ allowPrecision: true }),
            customRenderInputProp: ({ key }) =>
                lodash.merge(
                    { disabled: viewOnly, allowPrecision: true },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                )
        })
    );
    columns.push(
        createColumnInlineSelect({
            title: () => i18n.global.t("model.hazPackage.refUnit"),
            dataIndex: "refUnit",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: callHazPackageUnit, optLabel: "value" }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        list: callHazPackageUnit,
                        optLabel: "value",
                        "onUpdate:value": value => (record.refUnit = value)
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                )
        })
    );
    return columns;
};

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, canCreate, canDelete } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => (viewOnly ? false : canDelete),
            onClick: ({ rowSelection }) => {
                onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey });
                data.page.page = 0;
            }
        }),
        createManageExportCsv({ menuContext })
    ];
    data.manageExtras = [
        {
            render: () => createButtonCreate({ onClick: () => items.push({}) }),
            visible: () => (viewOnly ? false : canCreate)
        }
    ];
    data.rowActions = [];
    fetchData({ props, data }).then(page => items.push(...page.data));
};

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false));
};
